import { Component, OnInit } from "@angular/core";
import { LoginService } from "../app/login.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent implements OnInit {
  title = "Aweb";
  constructor(private loginS: LoginService, translate: TranslateService) {
    translate.setDefaultLang("en-US");
    /*// this language will be used as a fallback when a translation isn't found in the current language

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('he-IL');*/
  }
    ngOnInit(): void {
    const url = new URL(window.location.href);
    // Clean '_v' we added to force the browser to get the new V
    if (url.searchParams.has('_v')) {
      url.searchParams.delete('_v');
      window.history.replaceState({}, document.title, url.toString());
    }
  }
}
